import React from 'react';
import PropTypes from 'prop-types';
import { TextArea } from '@pwc/pwc-deals-ui';

const TextAreaFieldset = ({
  textareaLineHeight,
  field,
  maxLength,
  label,
  error,
  className,
  basic,
  placeholder,
  helperText,
  helperIcon,
  helperIconColor,
  disabled,
}) => {
  return (
    <>
      <TextArea
        error={error}
        label={label}
        field={field}
        basic={basic}
        className={className}
        maxLength={maxLength}
        placeholder={placeholder}
        helperText={helperText}
        helperIcon={helperIcon}
        helperIconColor={helperIconColor}
        disabled={disabled}
        textareaLineHeight={textareaLineHeight}
      />
    </>
  );
};

TextAreaFieldset.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  maxLength: PropTypes.number,
};

TextAreaFieldset.defaultProps = {
  error: '',
  maxLength: 1000,
  label: '',
};

export default TextAreaFieldset;
